module.exports = __webpack_public_path__ + "img/mood03.140c79f2.jpg";